import { KeyboardEvent, MouseEvent } from 'react';

/**
 * Props that make a table or list row open on click, Enter or Space. Rows hold cells with their
 * own controls (a URL's copy button, an input button and the menu it opens), so a row can't be a
 * <button>, and a click that lands on one of those controls is left to it. No role: the row keeps its own (row in a table, listitem in a
 * list), so screen readers keep the table and list structure.
 */
export function getRowPressProps(onPress: () => void) {
  return {
    tabIndex: 0,
    onClick: (event: MouseEvent<HTMLElement>) => {
      if (isInsideControl(event)) {
        return;
      }
      onPress();
    },
    onKeyDown: (event: KeyboardEvent<HTMLElement>) => {
      if (event.target !== event.currentTarget) {
        return;
      }
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onPress();
      }
    },
  };
}

function isInsideControl(event: MouseEvent<HTMLElement>): boolean {
  const control = (event.target as HTMLElement).closest(
    'button, a, input, [role="menu"], [role="dialog"]',
  );
  return (
    control !== null && event.currentTarget.contains(control) && control !== event.currentTarget
  );
}
